<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <template v-slot:activator="{ on }">
            <v-btn color="primary" dark v-on="on">Create member</v-btn>
        </template>
        <v-card
                :loading="loading"
                :disabled="loading"
        >

            <v-card-title>
                <span class="headline">Create Member</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="6" >
                            <v-text-field v-model="first_name" clearable label="Legal first name*" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" >
                            <v-text-field v-model="last_name" clearable label="Last name" hint="" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" >
                            <v-select
                                    :items="['-', 'F', 'M','O']"
                                    label="Sexe"
                                    v-model="gender"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="birth_date" clearable prepend-icon="mdi-calendar" label="Birthdate" type="date"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="email" clearable prepend-icon="mdi-email" label="Email*" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="phone_number" clearable prepend-icon="mdi-phone" label="Phone" type="phone"></v-text-field>
                        </v-col>
                        <v-row>
                            <v-col cols="12" sm="6" >
                                <v-switch v-model="generate_account" clearable label="Generate account"></v-switch>
                            </v-col>
                            <v-col cols="12" sm="6" >
                                <v-text-field v-if="generate_account" clearable v-model="account_pseudo" prepend-icon="mdi-account" label="pseudo" type="phone"></v-text-field>
                            </v-col>
                            <!--<v-input hint="I am hint" persistent-hint :messages="messages">Input</v-input>-->
                        </v-row>
                        <v-divider></v-divider>
                        <v-col cols="12">
                            <AddressInput @change="updateAddress($event)"/>
                        </v-col>

                    </v-row>
                </v-container>
                <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                <v-btn color="blue darken-1" text @click="createMember">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>


<script>
    import AddressInput from "../../templates/fields/AddressInput";
    import RhService from '../../../services/apps/rh.service'


    export default {
        name: 'CreateMemberDialog',
        components: {AddressInput},
        data: () => ({
            dialog: false,
            address: {},
            first_name: null,
            last_name: null,
            gender: null,
            birth_date: null,
            email: null,
            phone_number: null,
            loading: false,
            generate_account: false,
            account_pseudo: null,
            on: false,
        }),
        methods: {
            updateAddress(address){
                this.address = address
            },
            createMember(){
                this.loading = true;
                let address = this.address;
                if (Object.keys(address).length === 0) {
                    address = null
                }



                let member = {
                    first_name: this.first_name,
                    surname: this.last_name,
                    gender: this.gender,
                    address: address,
                    birth_date: this.birth_date,
                    email: this.email,
                    phone_number: this.phone_number,
                    generate_account: this.generate_account,
                    account_pseudo: this.account_pseudo,
                };

                console.log(member)

                RhService.createMember(member)
                    .then(res=>{
                        alert(res);
                        this.loading = false;
                        this.dialog = false;
                        console.log(res);
                        this.$emit('change', res.data);
                    })
                    .catch(err=>{
                        alert(err)
                        this.loading = false
                    })
            }
        }
    }
</script>
